import React, { useState, useEffect } from "react";
import _ from "lodash";

import { OpenCalcButtons } from "./components/OpenCalcButtons";
import { CustomCalculator } from "./components/CustomCalculator";
import { FooterLinks } from "./components/FooterLinks";
import { DesktopTitles } from "./components/DesktopTitles";
import useCalc from "hooks/useCalc";

import "./style.scss";

export const TripleCalc = ({ labels }) => {
  const [showOpenBtnsOnMob, setShowOpenBtnsOnMob] = useState(true);
  const [showCustomCalcOnMob, setShowCustomCalcOnMob] = useState(false);
  const [chosenFields, setChosenFields] = useState(["maturity", "psycho"]);
  const [unchosenField, setUnchosenField] = useState("adapter");
  const {
    buildJsonAndCallLastScore, 
    scoresData, 
    handleChange,
    formFields,
    validate,
    checkIfInvalid,
    showResult,
    resetCalc,
    handleSaveToPersonal,
    showRegister,
    setShowRegister
  } = useCalc(labels, chosenFields);

  const handleClickOpenCalc = (chosen, unchosen) => {
    setChosenFields(chosen);
    setUnchosenField(unchosen);
    setShowOpenBtnsOnMob(false);
    setShowCustomCalcOnMob(true);
  }

  const handleClickCalcAgain = () => {
    setShowOpenBtnsOnMob(true);
    setShowCustomCalcOnMob(false);
    resetCalc();
  }

  useEffect(() => {
    resetCalc();
  },[chosenFields])

  return (
    <div>
    <DesktopTitles labels={labels}/>
    <div className="triple-calc">
      <div className="btns-and-calcs">
        <OpenCalcButtons handleClickOpenCalc={handleClickOpenCalc} labels={labels} showOpenBtnsOnMob={showOpenBtnsOnMob}/> 
        <CustomCalculator 
          labels={labels} 
          chosenFields={chosenFields} 
          unchosenField={unchosenField}
          parentHandleClickCalcAgain={handleClickCalcAgain} 
          showCustomCalcOnMob={showCustomCalcOnMob}
          formFields={formFields}
          buildJsonAndCallLastScore={buildJsonAndCallLastScore}
          scoresData={scoresData}
          handleChange={handleChange}
          validate={validate}
          checkIfInvalid={checkIfInvalid}
          showResult={showResult}
        /> 
      </div>
      <FooterLinks 
        labels={labels} 
        handleSaveToPersonal={handleSaveToPersonal} 
        showRegister={showRegister} 
        setShowRegister={setShowRegister}
      />
    </div>
    </div>
  )
}